import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Works\DimensionsParseController::__invoke
* @see app/Http/Controllers/Works/DimensionsParseController.php:19
* @route '/works/{work}/dimensions/parse'
*/
export const parse = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: parse.url(args, options),
    method: 'post',
})

parse.definition = {
    methods: ["post"],
    url: '/works/{work}/dimensions/parse',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Works\DimensionsParseController::__invoke
* @see app/Http/Controllers/Works/DimensionsParseController.php:19
* @route '/works/{work}/dimensions/parse'
*/
parse.url = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { work: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'slug' in args) {
        args = { work: args.slug }
    }

    if (Array.isArray(args)) {
        args = {
            work: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        work: typeof args.work === 'object'
        ? args.work.slug
        : args.work,
    }

    return parse.definition.url
            .replace('{work}', parsedArgs.work.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Works\DimensionsParseController::__invoke
* @see app/Http/Controllers/Works/DimensionsParseController.php:19
* @route '/works/{work}/dimensions/parse'
*/
parse.post = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: parse.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Works\DimensionsParseController::__invoke
* @see app/Http/Controllers/Works/DimensionsParseController.php:19
* @route '/works/{work}/dimensions/parse'
*/
const parseForm = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: parse.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Works\DimensionsParseController::__invoke
* @see app/Http/Controllers/Works/DimensionsParseController.php:19
* @route '/works/{work}/dimensions/parse'
*/
parseForm.post = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: parse.url(args, options),
    method: 'post',
})

parse.form = parseForm

const dimensions = {
    parse: Object.assign(parse, parse),
}

export default dimensions